import { useEffect, useState } from "react";
import type { ColumnDef } from "@tanstack/react-table";
import { fetchOrganizations } from "../lib/api";
import type { Organization } from "../lib/types";
import DataTable from "../components/DataTable";
import WriteOpsHint from "../components/WriteOpsHint";
import { ORGS_WRITE_OPS } from "../writeops/orgs";

const COLS: ColumnDef<Organization, any>[] = [
  { header: "ID", accessorKey: "id" },
  { header: "Display Name", accessorKey: "display_name" },
  {
    header: "Erstellt",
    accessorKey: "created_at",
    cell: (c) => (
      <span className="font-mono text-xs text-kw-text-muted">
        {String(c.getValue() ?? "")}
      </span>
    ),
  },
];

export default function OrgsRoute() {
  const [orgs, setOrgs] = useState<Organization[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        setOrgs(await fetchOrganizations());
      } catch (e: any) {
        setError(e.message ?? String(e));
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="px-8 py-6 space-y-6">
      <h2 className="text-lg font-medium">Organizations</h2>
      {loading && <div className="text-kw-text-muted text-sm">Lade...</div>}
      {error && <div className="text-red-400 text-sm">{error}</div>}
      {!loading && !error && (
        <DataTable
          columns={COLS}
          data={orgs}
          emptyHint="Keine Organizations angelegt — bisher P5.6 nur Schema vorbereitet."
        />
      )}
      <WriteOpsHint title="Organization-Write-Ops" ops={ORGS_WRITE_OPS} />
    </div>
  );
}
